export default __webpack_public_path__ + "static/media/lab-activity-05.63cf755a.jpg";